<button mat-flat-button color="primary" (click)="openScheduleMeetingDialog()">
  <mat-icon> add </mat-icon> {{ 'MEETING_SCHEDULER.MEETING_ACTION.DIALOG.BOOK_MEETING' | translate }}
</button>
